import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { parentClinicsDataSource } from 'infrastructure/data-sources/parent-clinics';

import type { IParentClinicItem } from 'infrastructure/data-sources/parent-clinics';
import type { ParentClinicOption } from 'infrastructure/enums/parent-clinic';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IParentClinicItem['id'],
  IParentClinicItem
>[];

interface IClinicDropdownSelectBoxProps
  extends Omit<IBaseSelectBoxProps<ParentClinicOption>, 'options'> {}

const ClinicDropdownSelectBox: React.FC<IClinicDropdownSelectBoxProps> = (
  props,
) => {
  const dataSource = useMemo(() => parentClinicsDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClinicDropdownSelectBox;
